import type { AuthStaff } from '@/store/authStore';

import { api } from '../api';

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  staff: AuthStaff;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  const res = await api.post<LoginResponse>('/auth/login', { username, password });
  return res.data;
}

export async function getMe(): Promise<AuthStaff> {
  const res = await api.get<AuthStaff>('/auth/me');
  return res.data;
}
